import { Button, CellContentPosition, Icon, IconButton, Stack, TableCell, TableRow } from "@tm/components"
import { CustomArticleListResponse } from "@tm/data/basket"
import { useLocalization } from "@tm/localization"
import { formatDate } from "@tm/utils"

type CompilationRowProps = {
    compilation: CustomArticleListResponse
    onClickDetails(compilation: CustomArticleListResponse): void
    onClickDelete(compilation: CustomArticleListResponse): void
    onClickEdit(compilation: CustomArticleListResponse): void
}

export function CompilationRow(props: CompilationRowProps) {
    const { compilation, onClickDelete, onClickDetails, onClickEdit } = props
    const { translateText } = useLocalization()

    function handleClickDetails() {
        onClickDetails(compilation)
    }

    function handleClickDelete(e: React.MouseEvent<HTMLButtonElement>) {
        e.stopPropagation()
        onClickDelete(compilation)
    }

    function handleClickEdit(e: React.MouseEvent<HTMLButtonElement>) {
        e.stopPropagation()
        onClickEdit(compilation)
    }

    function renderDate(date: Date | undefined) {
        if (!date) {
            return
        }

        return formatDate(date, "d")
    }

    return (
        <TableRow colCount={5} onClick={handleClickDetails} sx={{ cursor: "pointer" }} rowCap={4}>
            <TableCell>{compilation.name}</TableCell>
            <TableCell>{compilation.description}</TableCell>
            <TableCell>{renderDate(compilation.createDate)}</TableCell>
            <TableCell>{renderDate(compilation.updateDate)}</TableCell>
            <TableCell alignContent={CellContentPosition.right} sx={{ py: "3px" }}>
                <Stack direction="row" gap={1}>
                    <IconButton title={translateText(122)} onClick={handleClickEdit}>
                        <Icon name="edit_change" />
                    </IconButton>
                    <IconButton title={translateText(624)} onClick={handleClickDelete}>
                        <Icon name="delete" />
                    </IconButton>
                    <Button onClick={handleClickDetails} endIcon={<Icon name="details" />} variant="contained">
                        {translateText(43)}
                    </Button>
                </Stack>
            </TableCell>
        </TableRow>
    )
}
